// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root_3LZCU","container":"Login_container_1VV_8","logo":"Login_logo_1erWp","title":"Login_title_1vK51","form":"Login_form_2Rk3H","footer":"Login_footer_2N09L"};